export const emoji_smile = () => (
  <path
    d="M8 11s1.5 2 4 2 4-2 4-2M9 8h.01M15 8h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
